var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFondocifra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.444,
    height: 71.934,
    viewBox: "0 0 215.444 71.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1650",
    "data-name": "Grupo 1650",
    transform: "translate(-1566.053 319.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1642",
    "data-name": "Grupo 1642",
    transform: "translate(1584.232 -319.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M398.414,213.769c-4.773,4.759-15.007,7.395-29.089,8.533,4.559.484,16.446.487,13.371,2.819-13.474,10.218-79.836,6.23-124.171-7.6-48.192-15.028-50.572-36.629-36.419-43.1,17.761-8.123,56.414-5.118,62.257-4.685-2.452,1.239-6.168,1.373-7.345,3.694,9.808-3.08,19.8-3.644,29.865-3.1-21.055-3.632-48.018-4.367-66.51-3.479-32.928,1.583-46.425,20.753-31.545,36.756,47.739,51.343,209.264,38.138,189.588,10.162",
    transform: "translate(-202.802 -166.51)",
    fill: "#ff6623",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1414",
    "data-name": "Trazado 1414",
    d: "M211.5,170.07c-76.372,17.883-2.791,59.043,44.214,66.71-83.505-27.808-74.269-57.82-44.214-66.71",
    transform: "translate(1387.609 -486.597)",
    fill: "#ff6623",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondocifra);
export default __webpack_public_path__ + "static/media/fondocifra.1c1e8590518f435764a032590cd195a5.svg";
export { ForwardRef as ReactComponent };